<template>
  <div>
    <v-stage
        ref="stage"
        :config="config">
      <v-layer
          ref="layer">
        <v-group
            v-for="zone in drawnZones()"
            :ref="'group-'+zone.uniqueId"
            :key="zone.uniqueId"
            :data="zone"
            :config="zone.config.group"
            @mousedown="handleGroupMousedown"
            @dragend="handleGroupDragend">
          <v-line
              :ref="'line-'+zone.uniqueId"
              :config="zone.config.line"
              :data="zone"
              @click="handleLineClick" />
          <v-circle
              v-for="point in zone.vertices"
              v-if="draggable"
              :ref="'circle-'+point.uniqueId"
              :key="point.uniqueId"
              :data="point"
              :config="zone.config.circles"
              :x="point.ui.x"
              :y="point.ui.y"
              :radius="4"
              :visible="zone.selected"
              @dragmove="handleCircleDragmove"
              @mouseenter="handleCircleMouseenter"
              @mouseleave="handleCircleMouseleave" />
        </v-group>
      </v-layer>
    </v-stage>

    <!--el-button
        @click="showZones()">
      show
    </el-button-->

    <!--span
        v-for="zone in drownZones(zones)"
        :key="zone.uniqueId">{{ zone.name }} {{ zone.selected }}</span-->
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  name: "MotionZonesCanvas",
  props: {
    zones: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      draggable: false,
    };
  },
  watch: {
    zones: {
      handler() {
        this.updateSelectedZone();
      },
      deep: true,
    },
  },
  mounted() {
    this.draggable = !!this.config.draggable;
    this.config.draggable = false;
    //this.showZones();
    this.updateSelectedZone();
    this.$nextTick(() => {
      //this.fixGroupsDragBounds();
    });
  },
  methods: {
    drawnZones() {
      return this.zones.filter((zone) => zone.drawn);
    },
    findZoneByUniqueId(uniqueId) {
      return this.zones.find((zone) => zone.uniqueId === uniqueId);
    },
    selectZone(zone) {
      if (!zone) return;
      const zoneUniqueId = zone.uniqueId;
      this.drawnZones().forEach(
        (zone) => (zone.selected = zone.uniqueId === zoneUniqueId)
      );
      this.updateSelectedZone();
    },
    handleCircleDragmove(e) {
      const point = e.target.attrs.data;
      point.ui.x = e.target.attrs.x;
      point.ui.y = e.target.attrs.y;
      point.x = point.ui.x / this.config.width;
      point.y = point.ui.y / this.config.height;

      const line = this.$refs["line-" + point.zone.uniqueId][0].getNode();
      line.attrs.points = point.zone.vertices
        .map((point) => [point.ui.x, point.ui.y])
        .flat();
      point.zone.vertices.updated = true;

      //this.updateZoneUIInfo(point.zone);
    },
    handleCircleMouseenter() {
      if (!!this.config.draggable) {
        const stage = this.$refs.stage.getStage();
        stage.container().style.cursor = "pointer";
      }
    },
    handleCircleMouseleave() {
      if (!!this.config.draggable) {
        const stage = this.$refs.stage.getStage();
        stage.container().style.cursor = "default";
      }
    },
    handleGroupMousedown(e) {
      const zoneUniqueId = e.target.attrs.data.uniqueId;
      this.selectZone(this.findZoneByUniqueId(zoneUniqueId));
    },
    handleGroupDragend(e) {
      const zoneUniqueId = e.target.attrs.data.uniqueId;
      const zone = this.findZoneByUniqueId(zoneUniqueId);
      if (!zone) return;

      zone.vertices.forEach((point) => {
        const circles = this.$refs["circle-" + point.uniqueId];
        if (circles && circles.length) {
          const position = circles[0].getNode().absolutePosition();
          point.x = position.x / this.config.width;
          point.y = position.y / this.config.height;
        }
      });
      zone.vertices.updated = true;
      //6this.updateZoneUIInfo(zone);
    },
    handleLineClick(e) {
      const zoneUniqueId = e.target.attrs.data.uniqueId;
      this.selectZone(this.findZoneByUniqueId(zoneUniqueId));
    },
    updateSelectedZone() {
      if (!this.zones || !this.zones.length) return;

      let redraw = false;

      this.drawnZones().forEach((zone) => {
        zone.vertices.forEach((point) => {
          const circles = this.$refs["circle-" + point.uniqueId];
          if (circles && circles.length) {
            circles[0].getNode().visible(!!zone.selected);
            redraw = true;
          }
        });
      });

      if (redraw) this.$refs.layer.getNode().draw();
    },
    fixGroupsDragBounds() {
      if (!this.zones || !this.zones.length) return;
      if (!this.draggable) return;

      this.drawnZones().forEach((zone) => {
        const groups = this.$refs["group-" + zone.uniqueId];
        if (groups && groups.length) {
          const group = groups[0].getNode();

          this.updateZoneUIInfo(zone);

          group.attrs.dragBoundFunc = (pos) => {
            const _zone = this.findZoneByUniqueId(group.attrs.data.uniqueId);
            const _clientRect = _zone.ui.clientRect;
            const _stage = _zone.ui.stage;

            /*
            console.log({
              a: 2,
              id: _zone.uniqueId,
              x: _zone.ui.clientRect.x,
              y: _zone.ui.clientRect.y,
              w: _zone.ui.clientRect.width,
              h: _zone.ui.clientRect.height,
            });
            */

            let x = pos.x;
            if (_clientRect.x + pos.x <= 0) {
              x = -_clientRect.x;
            } else if (
              _clientRect.x + _clientRect.width + pos.x >
              _stage.width
            ) {
              x = _stage.width - _clientRect.width - _clientRect.x;
            }

            let y = pos.y;
            if (_clientRect.y + pos.y <= 0) {
              y = -_clientRect.y;
            } else if (
              _clientRect.y + _clientRect.height + pos.y >
              _stage.height
            ) {
              y = _stage.height - _clientRect.height - _clientRect.y;
            }

            return { x, y };
          };
        }
      });
    },
    updateZoneUIInfo(zone) {
      const stage = this.$refs.stage.getStage();
      const line = this.$refs["line-" + zone.uniqueId][0].getNode();
      const clientRect = line.getClientRect({ relativeTo: stage });

      zone.ui = {
        clientRect: {
          x: clientRect.x,
          y: clientRect.y,
          width: clientRect.width,
          height: clientRect.height,
        },
        stage: {
          width: stage.width(),
          height: stage.height(),
        },
      };

      /*
      console.log({
        a: 1,
        id: zone.uniqueId,
        x: zone.ui.clientRect.x,
        y: zone.ui.clientRect.y,
        w: zone.ui.clientRect.width,
        h: zone.ui.clientRect.height,
      });
      */
    },
    showZones() {
      return;
      const points = [];
      this.drawnZones().forEach((zone) => {
        zone.vertices.forEach((point) => {
          points.push([point.x.toFixed(3), point.y.toFixed(3)]);
        });
      });
      console.log(points.flat());
    },
  },
};
</script>

<style lang="scss">
/* [role="presentation"] */
div.konvajs-content {
  background: #f5f5f5 !important;
  border-radius: 10px !important;
}
</style>
